import ArticleLayout from "@/pages/articles/components/ArticleLayout";

export default function YoybuyDlyaNachinayushih() {
  return <ArticleLayout slug="yoybuy-dlya-nachinayushih" />;
}